import { useCallback } from 'react';
import { LessonForm } from 'components/views/editor/models/LessonForm';
import { LessonFormValidationErrors } from 'models/LessonFormValidationErrors';
import { GameEditorData } from 'components/views/editor/gameEditor/models/GameEditorData';

interface UseTrainingPageCallbacksProps {
    setLessonFormData: (data: LessonForm | null) => void;
    setEditor: (editor: any) => void;
    setGameEditorData: (data: GameEditorData) => void;
    formValidationErrors: LessonFormValidationErrors;
    resetFormErrors: (fields: (keyof LessonForm)[]) => void;
}

export const useTrainingPageCallbacks = ({
                                             setLessonFormData,
                                             setEditor,
                                             setGameEditorData,
                                             formValidationErrors,
                                             resetFormErrors
                                         }: UseTrainingPageCallbacksProps) => {

    const handleFormDataChange = useCallback((
        lessonFormField: keyof LessonForm,
        newLessonFormData: LessonForm
    ) => {
        setLessonFormData(newLessonFormData);
        if (Object.keys(formValidationErrors).length > 0) {
            resetFormErrors([lessonFormField]);
        }
    }, [formValidationErrors, resetFormErrors, setLessonFormData]);

    const onEditorChange = useCallback((editor: any) => {
        setEditor(editor);
    }, [setEditor]);

    const onGameEditorChange = useCallback((data: GameEditorData) => {
        setGameEditorData(data);
    }, [setGameEditorData]);

    return {
        handleFormDataChange,
        onEditorChange,
        onGameEditorChange
    };
};